module.exports = __webpack_public_path__ + "static/media/pnid-contextualization.64eac02e.png";